module.exports = __webpack_public_path__ + "static/media/11.8ad48f6a.jpg";